import { render } from "./CameraIcon.vue?vue&type=template&id=6c2bd5b4&scoped=true"
import script from "./CameraIcon.vue?vue&type=script&lang=js"
export * from "./CameraIcon.vue?vue&type=script&lang=js"

import "./CameraIcon.vue?vue&type=style&index=0&id=6c2bd5b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2bd5b4"]])

export default __exports__